
import { apiClientServer } from './apiClientServer';


export const usuariosApi = apiClientServer("admin");
export const authApi = apiClientServer("auth");
export const opsApi = apiClientServer("op");
export const carritoApi = apiClientServer("carrito");
export const abonosApi = apiClientServer("abono");
export const gastosApi = apiClientServer("gastos");
export const productosApi = apiClientServer("producto");
export const proveedorApi = apiClientServer("proveedor");
export const categoriaApi = apiClientServer("categoria");
export const uploadsApi = apiClientServer("uploads");
export const cotizacionApi = apiClientServer("cotizacion");
export const buscarApi = apiClientServer("busqueda");
export const slideShowApi = apiClientServer("slideshow");
export const trasabilidadApi = apiClientServer("trasabili");
export const unidadesMedidaApi = apiClientServer("medidas");
export const inventarioApi = apiClientServer("inventario");
export const abonoGastosApi = apiClientServer("abonosf");
export const reporteStockApi = apiClientServer("reporteinv");
export const lotesApi = apiClientServer("lotes");
export const notasApi = apiClientServer("notas");


export const apiClienteGenerica = apiClientServer('', 'cliente');
















export * from './opsApi';